module.exports = __webpack_public_path__ + "img/traceability.647f198f.svg";